import { render } from "./ChatAdvert.vue?vue&type=template&id=3e7b0a06&scoped=true"
import script from "./ChatAdvert.vue?vue&type=script&lang=js"
export * from "./ChatAdvert.vue?vue&type=script&lang=js"

import "./ChatAdvert.vue?vue&type=style&index=0&id=3e7b0a06&lang=scss&scoped=true"

import exportComponent from "D:\\myGithub\\customer-web-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7b0a06"]])

export default __exports__